import path from "../../../../packages/fnacdarty-svg-ref-loader/svg-id.js?id=$!./recent.svg"; export default path + "#$"